import "./HomePage.css";
import Slogan from "../components/Layout/Slogan";
import Background from "../components/Layout/Background";


const Homepage = () => {
    return (
        <div>
            <Slogan/>
            <Background/>
        </div>
    );
}

export default Homepage;